import { Star } from "lucide-react";

export const StarPicker = ({ value = 0, onChange, testid }) => (
  <span className="inline-flex items-center gap-1" data-testid={testid}>
    {[1, 2, 3, 4, 5].map((n) => (
      <button key={n} type="button" onClick={() => onChange(value === n ? 0 : n)} data-testid={testid ? `${testid}-${n}` : undefined}
        className="transition-transform hover:scale-110">
        <Star size={20} className={n <= value ? "fill-[#E0A63C] text-[#E0A63C]" : "text-muted-foreground/30"} />
      </button>
    ))}
    {value > 0 && <span className="text-xs text-muted-foreground ml-1">{value}/5</span>}
  </span>
);

export const StarsRO = ({ value = 0 }) => (
  <span className="inline-flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} size={13} className={n <= value ? "fill-[#E0A63C] text-[#E0A63C]" : "text-muted-foreground/25"} />
    ))}
  </span>
);
